import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledCollectionFieldProfileCard = styled(Box)`
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;

  transition: ${props => props.theme.transitions.create(['height'], {
    easing: props.theme.property('transitions.easing.easeOut'),
    duration: props.theme.property('transitions.duration.leavingScreen')
  })} !important;

  .ProfileCardContent {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .ProfileCard {
    &-header {
      position: absolute;
      width: 100%;
      z-index: 1;
      pointer-events: none;

      .MuiCardHeader-action {
        display: flex;
        flex-direction: column-reverse;
        gap: ${props => props.theme.layout('0.5sp')};
        pointer-events: all;
      }
    }
  }

  &.CollectionFieldProfileCard {
    &:hover {
      .FieldCard-title {
        width: calc(100% - ${props => props.theme.spacing(3)});
      }
    }
  }

  &.CollectionFieldProfileCard-isDeleted {
    visibility: hidden;
  }
  
  ${ComponentStyles}
`;

StyledCollectionFieldProfileCard.propTypes = {
  theme: PropTypes.object
};

export default StyledCollectionFieldProfileCard;
